'use strict';

var App = require('app');
var AppState = require('app_state');
var BatchSelectValuesView = require('components/common/views/batch_select_values_view');
var BatchWriteDialogView = require('components/devices/views/common/batch_write_dialog_view');
var DeviceListView = require('components/devices/views/tools/stats/stats_dialog_device_list_view');
var DeviceSelection = require('utils/device_selection');
var Misc = require('utils/misc');
var OOP = require('utils/oop');

var StatsDialogView = OOP.extend(
    Marionette.LayoutView,
    {
        template: require('components/devices/templates/tools/stats/stats_dialog'),
        columns: [],
        ui: {
            ddlColumns: 'select.js-column',
            write: '#js-write',
            config: '#js-config',
        },
        regions: {
            valueList: '#value-list',
            deviceTableView: '.dataTable',
        },
        events: {
            'change select.js-column': 'modifyColumns',
            'click .js-delete-column': 'deleteColumn',
            'click .js-table-row-select': 'updateWriteButton',
            'click @ui.write': 'write',
            'click @ui.config': 'batchConfiguration',
        },

        backgroundTasks: Misc.getBackgroundTaskManager(),

        initialize: function (data) {
            this.request = data.request;
            this.metaData = data.metaData;
            this.controller = data.controller;
        },

        onShow: function () {
            if (!this.deviceList) {
                this.loadDeviceList();
            }
        },

        createListView: function (list) {
            var self = this;
            list = list || this.lastList;
            this.lastList = list;
            if (!this.lastList) return;

            var tablePage = {};
            if (this.deviceListView) {
                tablePage = this.deviceListView.getTablePage() || {};
            }

            this.selectionCtx =
                this.selectionCtx ||
                new DeviceSelection({
                    filter: {
                        selection: this.request.selectionID,
                    },
                    onUpdate: function () {
                        self.triggerUpdate();
                    },
                });

            this.deviceListView = new DeviceListView({
                controller: this.controller,
                collection: tablePage.collection || list.items,
                itemCount: list.count,
                listResult: list.listResult,
                columns: this.buildColumns(),
                stats: this.stats,
                ownerView: this,
                tablePage: tablePage || {},
                selectionCtx: this.selectionCtx,
                categories: this.request.columnCategories,
            });
            this.showChildView('deviceTableView', this.deviceListView);
        },

        triggerUpdate: function () {
            this.updateWriteButton();

            var self = this;
            if (!this.thrUpdate) {
                this.thrUpdate = Misc.throttle(
                    function () {
                        if (!self.isDestroyed) {
                            self.recalculate();
                        }
                    },
                    1000,
                    2000
                );
            }

            this.thrUpdate();
        },

        buildColumns: function () {
            var cols = Misc.selectWhere(this.columns, undefined, function (item) {
                var field = Misc.columnNameToField(item);
                var data = AppState.availableColumnData(field);
                return {
                    id: item,
                    name: data.name,
                };
            });
            return cols;
        },

        loadDeviceList: function () {
            var self = this;
            this.backgroundTasks
                .whenArray([
                    App.request('device:list', {
                        cache: true,
                        filterParams: { limit: AppState.getItemsPerPage() || 20 },
                        filter: { selection: this.request.selectionID },
                    }),
                ])
                .done(function (list, meta) {
                    self.lastList = list;
                    self.recalculate();
                });
        },

        onRender: function () {
            this.createListView();
            Misc.initSelectPicker();
            $('.modal-dialog').addClass('modal-lg');
        },

        serializeData: function () {
            var data = this.base.serializeData();
            var fields = AppState.uniqueFields(this.request.columnCategories);
            data.datacolumns = Misc.getAvailableDisplayColumns(fields);
            data.columns = _.flatten([this.columns, [{}]]);
            data.isLoading = this.lastList === undefined;
            data.hasDevices = data.isLoading ? false : this.lastList.count > 0;
            data.noSelection = this.deviceListView && this.deviceListView.collection.selectedLength == 0;
            return data;
        },

        recalculate: function () {
            if (this.isRecalculating) return;
            this.isRecalculating = true;

            var currentChangeIdx = this.selectionCtx ? this.selectionCtx.changeIdx : undefined;
            var self = this;
            var statsData = {
                series: Misc.selectWhere(
                    this.columns,
                    function (item) {
                        var parts = item.split('_');
                        return parts.length == 2 && !isNaN(parseInt(parts[1]));
                    },
                    function (item) {
                        return { value: item };
                    }
                ),
                filter: {},
            };

            if (!statsData.series.length) {
                this.render();
                this.isRecalculating = false;
                return;
            }

            this.backgroundTasks
                .when(
                    App.request(
                        'statistics:calculate',
                        statsData,
                        this.selectionCtx.selectionID || this.request.selectionID
                    )
                )
                .done(function (result) {
                    var newChangeIdx = self.selectionCtx ? self.selectionCtx.changeIdx : undefined;
                    if (currentChangeIdx != newChangeIdx) {
                        // selection changed: calculate again
                        self.isRecalculating = false;
                        self.recalculate();
                        return;
                    }

                    self.stats = statsData;
                    self.render();
                    self.isRecalculating = false;
                });
        },

        modifyColumns: function () {
            // read all columns
            this.columns = Misc.selectWhere(
                this.ui.ddlColumns,
                function (item) {
                    return $(item).val();
                },
                function (item) {
                    return $(item).val();
                }
            );
            this.recalculate();
        },

        deleteColumn: function (e) {
            e.preventDefault();

            if (this.columns.length > 0) {
                var pos = parseInt(e.currentTarget.id.substring(7));

                this.columns.splice(pos, 1);
                this.recalculate();
            }
        },

        updateWriteButton: function () {
            if (this.deviceListView) {
                this.ui.write[0].disabled = this.deviceListView.collection.selectedLength == 0;
            }
        },

        write: function () {
            App.showModal(
                new BatchWriteDialogView({
                    controller: this.controller,
                    collection: this.deviceListView.collection,
                })
            );
        },

        batchConfiguration: function () {
            App.showModal(
                new BatchSelectValuesView({
                    controller: this.controller,
                    collection: this.deviceListView.collection,
                })
            );
        },
    },
    'StatsDialogView'
);

module.exports = StatsDialogView;
